import { MessageType, useMessageReceiver } from '@farmasiet/iframe-messages';
import React, { useState } from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { SessionStorageAccessor } from '../../../StorageAccessor/SessionStorageAccessor';
import { Snackbar } from '../Snackbar';

interface INewMessageSnackbarProps {
    inboxUrl: string;
    philUrl: string;
}

interface IMutedSnackbar {
    muteSince: number;
}

export const NewMessageSnackbar = (props: INewMessageSnackbarProps) => {
    const muteStorageKey = 'newMessageSnackbar:mute';
    const muteTime = 10 * 60 * 1000;
    const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

    useMessageReceiver(props.philUrl, MessageType.NEW_MESSAGE, () => showSnackbar());

    const showSnackbar = () => {
        const muteSnackbarString = SessionStorageAccessor.getItem(muteStorageKey);

        if (muteSnackbarString) {
            const muteSnackbar = JSON.parse(muteSnackbarString) as IMutedSnackbar;
            if (muteSnackbar.muteSince > new Date().getTime()) return;
        }

        setIsSnackbarVisible(true);
    };

    const closeSnackbar = () => {
        setIsSnackbarVisible(false);
        muteSnackbar();
    };

    const muteSnackbar = () => {
        const muteSnackbar: IMutedSnackbar = {
            muteSince: new Date(new Date().getTime() + muteTime).getTime()
        };

        SessionStorageAccessor.setItem(muteStorageKey, JSON.stringify(muteSnackbar));
    };

    return (
        <Snackbar
            className="NewMessageSnackbar"
            isVisible={isSnackbarVisible}
            heading={getTranslation(keys['newMessage.heading'])}
            text={getTranslation(keys['newMessage.content'])}
            linkUrl={props.inboxUrl}
            linkText={getTranslation(keys['newMessage.link'])}
            onClose={closeSnackbar}
            onLinkClick={muteSnackbar}
        />
    );
};
